import React from "react";

import VotifySearch from "./VotifySearch";
import FullScreenMenuComponent from "../FullScreenMenu/FullScreenMenuComponent";
import SocketIoComponent from "../SocketIoComponent/SocketIoComponent";
import VotifyWrapper from "./VotifyWrapper";
import VotifyContainer from "./PartyLayout/VotifyContainer";

import { getParamPairs } from "../../utils/utils";
import { tabNames } from "../../constants";

/**
 *
 * @param {*} param0
 *
 * We use url params for routing which tab should be open. The tab is found in location.search.
 * If the tab is undefined, the default tab is the "playback" tab with the song queue.
 */
const VotifyRoutes = ({ history, match, location }) => {
  const { tab } = getParamPairs(location.search);
  let component = <></>;
  switch (tab) {
    case tabNames.SEARCH:
      component = <VotifySearch />;
      break;
    case tabNames.SETTINGS:
      component = <FullScreenMenuComponent />;
      break;
    default:
      component = <VotifyContainer />;
  }
  return (
    <VotifyWrapper history={history} match={match} location={location}>
      <SocketIoComponent />
      {component}
    </VotifyWrapper>
  );
};

export default VotifyRoutes;
